import React from 'react';

import Icon from 'Core/Components/Icon';

const join = (...segments) => segments.filter(segment => segment && segment.length).join('-');

class OrderingControls extends React.Component {
  constructor (props) {
    super(props);
    this.getControls = this.getControls.bind(this);
  }

  getControls () {
    const { isFirst, isLast, iconStyle = 'angle', terminusModifier = 'double', horizontal } = this.props;
    const prev = horizontal ? 'left' : 'up';
    const next = horizontal ? 'right' : 'down';
    return [
      {
        id: 'start',
        disabled: isFirst,
        title: 'Move To Beginning',
        icon: join(iconStyle, terminusModifier, prev),
      },
      {
        id: 'prev',
        disabled: isFirst,
        title: 'Move Up',
        icon: join(iconStyle, prev),
      },
      {
        id: 'next',
        disabled: isLast,
        title: 'Move Down',
        icon: join(iconStyle,next),
      },
      {
        id: 'end',
        disabled: isLast,
        title: 'Move To End',
        icon: join(iconStyle, terminusModifier,next),
      },
    ];
  }

  render () {
    const { controlWrapper, handleMove } = this.props;
    const controls = this.getControls();
    return (
      <React.Fragment>
        {controls.map(control => {
          const { title, icon, id, disabled, className } = control;
          const wrapper = controlWrapper && typeof controlWrapper === 'function'
            ? controlWrapper
            : (contents) => contents;

          const handler = handleMove && typeof handleMove === 'function'
            ? handleMove
            : () => null;

          const style = !disabled
            ? null
            : { opacity: 0.5, pointerEvents: 'none' };

          return (
            <a onClick={() => handler(id, disabled)} key={id} title={title} style={style}>
              {wrapper(
                <Icon
                  fa={icon}
                  className={(
                    'OrderingControl'
                    + (disabled ? ' OrderingControl--disabled' : '')
                    + (className ? ` ${className}` : '')
                  )}
                />
              )}
            </a>
          );

        })}
      </React.Fragment>
    );
  }
};

export default OrderingControls;



// WEBPACK FOOTER //
// ./client/Core/Components/OrderingControls.jsx